module.exports = __webpack_public_path__ + "static/media/7.b68b3975.jpg";